import Decor1 from './Decoration1'
import Decor2 from './Decoration2'
import Decor3 from './Decoration3'

export const DecorList = [Decor1, Decor3, Decor2, Decor3]
